import { render, staticRenderFns } from "./commercial-lease.vue?vue&type=template&id=64bfa5ad"
import script from "./commercial-lease.vue?vue&type=script&lang=js"
export * from "./commercial-lease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports